<div class="position-relative height-100 flex-container-column-center bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<ic-change-language class="margin-left-auto margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	<div class="flex-0-0-auto margin-bottom-1rem header">
		{{ "auth.termsAndConditions.title" | translate }}
	</div>
	<div
		class="position-relative box-sizing-border-box width-100 flex-1-1-auto box-sizing-border-box overflow-y-auto text"
	>
		<ic-terms-conditions-text class="margin-bottom-1rem" (openBrowser)="openBrowser($event)" />
	</div>
	<div class="flex-0-0-auto footer">
		<button class="button-reset btn btn--secondary" (click)="decline()">
			{{ "auth.termsAndConditions.decline" | translate }}
		</button>
		<button class="button-reset btn btn--primary btn-accept" (click)="accept()">
			{{ "auth.termsAndConditions.accept" | translate }}
		</button>
	</div>
</div>
